import AreYouSureDialogMobileView from './mobile/AreYouSureDialog.mobile.view';
import AreYouSureDialogDesktopView from './desktop/AreYouSureDialog.desktop.view';
import type AreYouSureDialogProperties from './AreYouSureDialog.properties.ts';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function AreYouSureDialogView(props: AreYouSureDialogProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <AreYouSureDialogMobileView {...props} />}
      {isDesktop && <AreYouSureDialogDesktopView {...props} />}
    </>
  );
}
